/* ==========================================================================
   TRADA Editorial Minimalist - JS del tema
   Sin dependencias. Todo degrada a funcionalidad nativa de Shopify si falla JS.
   El carrito usa Cart API + Section Rendering API: Shopify siempre valida
   inventario y cantidades del lado del servidor.
   ========================================================================== */
(function () {
  'use strict';

  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartBusy = false;
  var cartMessage = '';

  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function lockScroll(locked) {
    document.body.style.overflow = locked ? 'hidden' : '';
  }

  /* ------------------------------------------------------------- Overlays */

  var lastFocused = null;

  function openOverlay(el) {
    if (!el) return;
    lastFocused = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var focusable = el.querySelector('[data-drawer-close], a, button, input');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  function closeOverlay(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!qs('.cart-drawer.is-open') && !qs('.mobile-menu.is-open')) lockScroll(false);
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus({ preventScroll: true });
      lastFocused = null;
    }
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    qsa('.cart-drawer.is-open, .mobile-menu.is-open').forEach(closeOverlay);
  });

  /* -------------------------------------------------- Carrito: utilidades */

  function sectionsToRender() {
    var ids = [];
    if (qs('[data-cart-drawer-content]')) ids.push('cart-drawer');
    if (qs('[data-cart-content]')) ids.push('main-cart');
    return ids.join(',');
  }

  function sectionsUrl() {
    return window.location.pathname + window.location.search;
  }

  function swapSection(doc, selector) {
    var fresh = doc.querySelector(selector);
    var current = qs(selector);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function renderCartSections(sections) {
    if (sections) {
      Object.keys(sections).forEach(function (key) {
        var html = sections[key];
        if (typeof html !== 'string') return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (key === 'cart-drawer') swapSection(doc, '[data-cart-drawer-content]');
        if (key === 'main-cart') swapSection(doc, '[data-cart-content]');
      });
    }
    syncCartCount();
    paintCartMessage();
  }

  // Vuelve a pedir las secciones al servidor (fuente de verdad del carrito).
  function refreshCart() {
    var ids = sectionsToRender();
    if (!ids) return Promise.resolve();

    var separator = sectionsUrl().indexOf('?') === -1 ? '?' : '&';

    return fetch(sectionsUrl() + separator + 'sections=' + ids, {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('sections');
        return response.json();
      })
      .then(renderCartSections)
      .catch(function () {
        /* si falla, se deja el DOM como está: el formulario nativo sigue sirviendo */
      });
  }

  function syncCartCount() {
    var source = qs('[data-cart-drawer-count]');
    if (!source) return;
    var count = parseInt(source.getAttribute('data-cart-drawer-count'), 10);
    if (isNaN(count)) return;
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function setCartMessage(message) {
    cartMessage = message || '';
    paintCartMessage();
  }

  function paintCartMessage() {
    qsa('[data-cart-error]').forEach(function (el) {
      el.textContent = cartMessage;
      el.hidden = cartMessage === '';
    });
  }

  function setLoading(el, loading) {
    if (el) el.classList.toggle('is-loading', !!loading);
  }

  /* ------------------------------------- Carrito: cambiar línea (cantidad) */

  function changeLine(line, quantity, scope) {
    if (cartBusy || isNaN(line) || isNaN(quantity) || quantity < 0) return Promise.resolve();

    cartBusy = true;
    setLoading(scope, true);

    return fetch(routes + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: sectionsToRender(),
        sections_url: sectionsUrl()
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          // Shopify rechazó la cantidad (por ejemplo, sin inventario suficiente).
          setCartMessage(result.data.description || result.data.message || 'No se pudo actualizar la cantidad.');
          return refreshCart();
        }
        setCartMessage('');
        renderCartSections(result.data.sections);
      })
      .catch(function () {
        window.location.href = routes + 'cart';
      })
      .finally(function () {
        cartBusy = false;
        setLoading(scope, false);
      });
  }

  /* ---------------------------------------------------- Cantidad: botones */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quantity-change]');
    if (!button) return;

    event.preventDefault();

    var wrapper = button.closest('.quantity');
    var input = wrapper ? qs('input', wrapper) : null;
    if (!input) return;

    var step = parseInt(button.getAttribute('data-quantity-change'), 10) || 0;
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = 0;

    var lineEl = button.closest('[data-cart-line]');

    if (lineEl) {
      // Carrito: no se toca el valor en pantalla; manda Shopify.
      var next = current + step;
      if (next < 0) next = 0;
      changeLine(parseInt(lineEl.getAttribute('data-cart-line'), 10), next, lineEl);
      return;
    }

    // Ficha de producto: respeta min/max/step de la variante.
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 0;
    var max = parseInt(input.getAttribute('max'), 10);
    var stepAttr = parseInt(input.getAttribute('step'), 10) || 1;

    var value = current + step * stepAttr;
    var note = qs('[data-quantity-note]', input.closest('.product-option') || document);

    if (value < min) value = min;
    if (!isNaN(max) && value > max) {
      value = max;
      if (note) {
        note.textContent = 'Solo quedan ' + max + ' unidades disponibles.';
        note.hidden = false;
      }
    } else if (note) {
      note.hidden = true;
    }

    input.value = value;
  });

  /* -------------------------------- Carrito: cantidad escrita y eliminar */

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-quantity]');
    if (!input) return;

    var lineEl = input.closest('[data-cart-line]');
    if (!lineEl) return;

    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) quantity = 0;

    changeLine(parseInt(lineEl.getAttribute('data-cart-line'), 10), quantity, lineEl);
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;

    var lineEl = remove.closest('[data-cart-line]');
    if (!lineEl) return; // sin línea, se sigue el enlace nativo de Shopify

    event.preventDefault();
    changeLine(parseInt(lineEl.getAttribute('data-cart-line'), 10), 0, lineEl);
  });

  /* --------------------------------------------- Overlays: abrir y cerrar */

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      var target = qs(opener.getAttribute('data-drawer-open'));
      if (target) {
        event.preventDefault();
        openOverlay(target);
      }
      return;
    }

    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeOverlay(closer.closest('.cart-drawer, .mobile-menu'));
    }
  });

  /* -------------------------------------------------------- Panel búsqueda */

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-search-toggle]');
    if (!toggle) return;
    event.preventDefault();

    var panel = qs('#SearchPanel');
    if (!panel) return;

    var isOpen = panel.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (isOpen) {
      var input = qs('input[type="search"]', panel);
      if (input) input.focus();
    }
  });

  /* ------------------------------------------------- Añadir al carrito AJAX */

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    var drawer = qs('#CartDrawer');
    if (!drawer || drawer.getAttribute('data-drawer-enabled') !== 'true') return; // va a /cart

    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var errorTarget = form.querySelector('[data-add-error]');
    if (errorTarget) {
      errorTarget.textContent = '';
      errorTarget.hidden = true;
    }
    if (button) button.setAttribute('aria-disabled', 'true');

    var body = new FormData(form);
    var ids = sectionsToRender();
    if (ids) {
      body.append('sections', ids);
      body.append('sections_url', sectionsUrl());
    }

    fetch(routes + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var message = result.data && (result.data.description || result.data.message);
          if (errorTarget) {
            errorTarget.textContent = message || 'No se pudo agregar el producto.';
            errorTarget.hidden = false;
          }
          return;
        }
        setCartMessage('');
        renderCartSections(result.data.sections);
        openOverlay(qs('#CartDrawer'));
      })
      .catch(function () {
        if (errorTarget) {
          errorTarget.textContent = 'No se pudo agregar el producto. Intenta de nuevo.';
          errorTarget.hidden = false;
        }
      })
      .finally(function () {
        if (button) button.removeAttribute('aria-disabled');
      });
  });

  /* --------------------------------------------------- Selector de variante */

  function VariantPicker(root) {
    this.root = root;

    var script = qs('[data-variants-json]', root);
    try {
      this.variants = JSON.parse(script.textContent);
    } catch (error) {
      this.variants = [];
    }

    this.idInput = qs('[data-variant-id]', root);
    this.priceTarget = qs('[data-price-target]', root);
    this.button = qs('[data-add-button]', root);
    this.buttonText = qs('[data-add-button-text]', root);
    this.qtyInput = qs('[data-product-quantity]', root);
    this.url = root.getAttribute('data-product-url');
    this.addLabel = (this.button && this.button.getAttribute('data-add-label')) || 'Añadir al carrito';

    root.addEventListener('change', this.onChange.bind(this));

    this.updateAvailability();
    var current = this.currentVariant();
    if (current) this.syncQuantity(current);
  }

  VariantPicker.prototype.selectedOptions = function () {
    return qsa('[data-option-group] input[type="radio"]:checked', this.root).map(function (input) {
      return input.value;
    });
  };

  VariantPicker.prototype.findVariant = function (options) {
    if (!options.length) return null;
    return this.variants.filter(function (variant) {
      return variant.options.every(function (option, index) {
        return option === options[index];
      });
    })[0];
  };

  VariantPicker.prototype.currentVariant = function () {
    var found = this.findVariant(this.selectedOptions());
    if (found) return found;

    var id = this.idInput ? parseInt(this.idInput.value, 10) : NaN;
    var byId = this.variants.filter(function (variant) {
      return variant.id === id;
    })[0];

    return byId || this.variants[0];
  };

  VariantPicker.prototype.onChange = function (event) {
    if (!event.target.matches('input[type="radio"]')) return;

    var group = event.target.closest('[data-option-group]');
    if (!group) return;

    var label = group.querySelector('[data-option-selected]');
    if (label) label.textContent = event.target.value;

    this.updateAvailability();

    var variant = this.findVariant(this.selectedOptions());

    if (!variant) {
      if (this.idInput) {
        this.idInput.value = '';
        this.idInput.disabled = true;
      }
      this.setButton(false, 'No disponible');
      return;
    }

    if (this.idInput) {
      this.idInput.value = variant.id;
      this.idInput.disabled = false;
    }

    this.setButton(variant.available, variant.available ? this.addLabel : 'Agotado');
    this.updatePrice(variant);
    this.syncQuantity(variant);
    this.updateImage(variant);

    if (this.url && window.history && window.history.replaceState) {
      window.history.replaceState({}, '', this.url + '?variant=' + variant.id);
    }
  };

  VariantPicker.prototype.setButton = function (enabled, text) {
    if (this.button) {
      this.button.disabled = !enabled;
      this.button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    }
    if (this.buttonText && text) this.buttonText.textContent = text;
  };

  // Los precios llegan ya formateados por el filtro money de Shopify.
  VariantPicker.prototype.updatePrice = function (variant) {
    if (!this.priceTarget) return;

    var html = '<span class="price__current">' + variant.price + '</span>';
    if (variant.compare_at_price) {
      html += '<span class="price__compare">' + variant.compare_at_price + '</span>';
    }

    this.priceTarget.innerHTML = html;
    this.priceTarget.classList.toggle('price--on-sale', !!variant.compare_at_price);
  };

  // min / max / incremento vienen de quantity_rule y del inventario real.
  VariantPicker.prototype.syncQuantity = function (variant) {
    if (!this.qtyInput) return;

    var min = variant.min || 1;
    var step = variant.step || 1;

    this.qtyInput.min = min;
    this.qtyInput.step = step;

    if (variant.max) {
      this.qtyInput.max = variant.max;
    } else {
      this.qtyInput.removeAttribute('max');
    }

    var value = parseInt(this.qtyInput.value, 10);
    if (isNaN(value) || value < min) value = min;
    if (variant.max && value > variant.max) value = variant.max;
    this.qtyInput.value = value;

    var note = qs('[data-quantity-note]', this.root);
    if (note) note.hidden = true;
  };

  VariantPicker.prototype.updateImage = function (variant) {
    if (!variant.image_id) return;
    var target = qs('[data-media-id="' + variant.image_id + '"]', this.root);
    if (!target) return;

    var gallery = qs('[data-gallery]', this.root);
    if (gallery && gallery.scrollWidth > gallery.clientWidth + 8) {
      // Carrusel: se mueve dentro de la galeria, no la pagina.
      gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      return;
    }

    if (typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  // Marca como agotada cada opción que, combinada con el resto de la selección
  // actual, no corresponde a ninguna variante disponible.
  VariantPicker.prototype.updateAvailability = function () {
    var selected = this.selectedOptions();
    var variants = this.variants;

    qsa('[data-option-group]', this.root).forEach(function (group, groupIndex) {
      qsa('.option-swatch', group).forEach(function (swatch) {
        var input = qs('input', swatch);
        if (!input) return;

        var candidate = selected.slice();
        candidate[groupIndex] = input.value;

        var match = variants.filter(function (variant) {
          return variant.options.every(function (option, index) {
            return option === candidate[index];
          });
        })[0];

        swatch.classList.toggle('option-swatch--unavailable', !match || !match.available);
      });
    });
  };

  var initialised = [];

  function initVariantPickers() {
    qsa('[data-variant-picker]').forEach(function (root) {
      if (initialised.indexOf(root) !== -1) return;
      initialised.push(root);
      new VariantPicker(root);
    });
  }

  initVariantPickers();

  // El editor de Shopify vuelve a renderizar secciones sin recargar la página.
  document.addEventListener('shopify:section:load', function () {
    initVariantPickers();
    syncCartCount();
  });

  /* --------------------------------------------------- Filtros de colección */

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-auto-submit]');
    if (!input) return;
    var form = input.closest('form');
    if (form) form.submit();
  });

  document.addEventListener('click', function (event) {
    qsa('details.facet[open]').forEach(function (facet) {
      if (!facet.contains(event.target)) facet.removeAttribute('open');
    });
  });

  /* --------------------------------------------- Galeria deslizable */

  // En movil la galeria es un carrusel con scroll-snap: los puntos solo
  // reflejan y controlan la posicion del scroll. Sin JS sigue deslizandose.
  function initGallery() {
    var gallery = qs('[data-gallery]');
    var dots = qsa('[data-gallery-dot]');
    if (!gallery || !dots.length) return;

    var slides = qsa('.product__media', gallery);

    function currentIndex() {
      var center = gallery.scrollLeft + gallery.clientWidth / 2;
      var index = 0;
      slides.forEach(function (slide, i) {
        if (slide.offsetLeft <= center) index = i;
      });
      return index;
    }

    function paint() {
      var index = currentIndex();
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    // Throttle por tiempo: no depende de requestAnimationFrame, que el
    // navegador congela cuando la pestana no esta visible.
    var lastPaint = 0;
    gallery.addEventListener(
      'scroll',
      function () {
        var now = Date.now();
        if (now - lastPaint < 60) return;
        lastPaint = now;
        paint();
      },
      { passive: true }
    );

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var slide = slides[i];
        if (!slide) return;
        gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
    });

    paint();
  }

  initGallery();

})();
